import React from "react";
import { string, bool, func } from "prop-types";

import "./checkbox.m.css";

const Checkbox = ({ text, isChecked, onChange }) => (
  <label styleName="checkbox-container" className="checkbox-container">
    <span styleName="label">{text}</span>
    <input type="checkbox" checked={isChecked} onChange={onChange} />
    <span styleName="checkmark" className="checkmark" />
  </label>
);

Checkbox.defaultProps = {
  isChecked: false
};

Checkbox.propTypes = {
  isChecked: bool,
  text: string,
  onChange: func
};

export default Checkbox;
